/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON, FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON, } from './FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromImportRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromImportRequest(value) {
    if (!('SocialIdentifierType' in value) || value['SocialIdentifierType'] === undefined)
        return false;
    if (!('SocialIdentifier' in value) || value['SocialIdentifier'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromImportRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromImportRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromImportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'GameSystemName': json['GameSystemName'] == null ? undefined : json['GameSystemName'],
        'Game': json['Game'] == null ? undefined : json['Game'],
        'SocialIdentifierType': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeFromJSON(json['SocialIdentifierType']),
        'SocialIdentifier': json['SocialIdentifier'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'GameSystemName': value['GameSystemName'],
        'Game': value['Game'],
        'SocialIdentifierType': FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierTypeToJSON(value['SocialIdentifierType']),
        'SocialIdentifier': value['SocialIdentifier'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromImportRequest.js.map